module.exports = __webpack_public_path__ + "static/media/ivan.392f84eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotos/ivan.jpg
// module id = 340
// module chunks = 0